import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import CookieConsent from './CookieConsent';

const CookieSettings = () => {
  const [showSettings, setShowSettings] = useState(false);

  const handleOpenSettings = () => {
    // Remove existing consent to trigger the banner again
    localStorage.removeItem('cookie-consent');
    // Force component to show by setting a temporary flag
    setShowSettings(true);
    // Reload to trigger the consent banner
    window.location.reload();
  };

  return (
    <>
      <button
        onClick={handleOpenSettings}
        className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center space-x-1"
        title="Cookie-Einstellungen ändern"
      >
        <Settings className="w-3 h-3" />
        <span>Cookies</span>
      </button>
      {showSettings && <CookieConsent />}
    </>
  );
};

export default CookieSettings; 